//import "https://player.vimeo.com/api/player.js";

var lockBody = function() {
    document.querySelector('body').classList.add('mix-bodyIsLocked')
};
var unLockBody = function() {
    document.querySelector('body').classList.remove('mix-bodyIsLocked')
};

document.querySelectorAll('.js-toggle').forEach(toggleContainer => {
    const target = toggleContainer.querySelector('.js-toggleTarget');
    const trigger = toggleContainer.querySelector('.js-toggleTrigger');

    if (!target || !trigger) {
        return;
    }

    trigger.addEventListener('click', e => {
        e.preventDefault();
        
        if (target.classList.contains('isOpen')) {
            target.classList.remove('isOpen');
            if (typeof unLockBody === 'function') {
                unLockBody();
            }
        } else {
            target.classList.add('isOpen');
            if (typeof lockBody === 'function') {
                lockBody();
            }
        }
    });

    document.querySelectorAll('.js-toggleClose').forEach(closeButton => {
        closeButton.addEventListener('click', function() {
            const closestTarget = this.closest('.js-toggleTarget');
            
            if (closestTarget) {
                closestTarget.classList.remove('isOpen');
                if (!closestTarget.classList.contains('isOpen')) {
                    if (typeof unLockBody === 'function') {
                        unLockBody();
                    }
                }
            }
        });
    });

    if (document.querySelector('.js-hasVimeoPlayer')) {
        trigger.addEventListener('click', () => {
            const playerContainer = trigger.nextElementSibling.querySelector('.vimeoPlayer');

            if (playerContainer) {
                const vimeoPlayer = new Vimeo.Player(playerContainer);
                vimeoPlayer.play().catch(error => console.error("Vimeo play failed:", error));
                document.querySelectorAll('.js-toggleClose').forEach(closeButton => {
                    closeButton.addEventListener('click', function() {
                        const ancestorTarget = this.closest('.js-toggleTarget');
                        if (ancestorTarget && ancestorTarget.contains(playerContainer)) {
                           vimeoPlayer.loadVideo(vimeoPlayer.element.src)
                        }
                    });
                });
            }
        });
    }
});